import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState, useContext, useEffect } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ThemeContext } from "../context/ThemeContext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ConfirmModal from "../components/ConfirmModal";
import PromptModal from "../components/PromptModal";

const ItemMaster = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  const [showForm, setShowForm] = useState(true); // Collapse / Expand control
  const [updateCheckboxItems, setUpdateCheckboxItems] = useState([]);
  const [selectCheckboxItems, setSelectCheckboxItems] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [searchItemCode, setSearchItemCode] = useState("");
  const [searchItemName, setSearchItemName] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [baseUOM, setBaseUOM] = useState("");
  const [partNumber, setPartNumber] = useState("");
  const [serialNumber, setSerialNumber] = useState("No");
  const [underMaintenance, setUnderMaintenance] = useState(false);
  const [tallySeparateHeader, setTallySeparateHeader] = useState(false);
  const [tallyHeaderName, setTallyHeaderName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [uomOptions, setUOMOptions] = useState([]);
  const [loading, setLoading] = useState(true);
const [isTallyButtonEnabled, setIsTallyButtonEnabled] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showTallyPrompt, setShowTallyPrompt] = useState(false);
  const [formError, setFormError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const parentCategory = location.state?.parentCategory;

  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId = localStorage.getItem("branchId") || "";
  const branch = localStorage.getItem("branchType") || "";
  const userId = localStorage.getItem("userId") || "";

  const commonHeaders = {
    "x-finyearid": finYearId,
    "x-finyear": finYear,
    "x-branchid": branchId,
    "x-branch": branch,
    "x-userid": userId,
  };

  const effectiveBranchId = Number(branchId || 0);

  const fetchItemList = async () => {
    if (!parentCategory?.fld_deepinnersubCategoryid) return;
    setLoading(true);
    try {
      const res = await axios.get("https://nissi-india.com/api/itemMasterList", {
        params: {
          deepInnerSubCategoryId: parentCategory.fld_deepinnersubCategoryid,
          itemcode: searchItemCode,
          itemname: searchItemName,
          branchId: 8,
          page,
          pageSize: limit,
        },
        headers: commonHeaders,
      });
      setItemList(res.data.items || []);
      setTotalPages(Math.ceil((res.data.totalCount || 0) / limit) || 1);
    } catch (err) {
      toast.error("Failed to fetch items");
    } finally {
      setLoading(false);
    }
  };

  const fetchUOMOptions = async () => {
    try {
      const res = await axios.get("https://nissi-india.com/api/item_uomList", {
        headers: commonHeaders,
      });
      setUOMOptions(res.data?.uomList || []);
    } catch (err) {
      toast.error("Failed to load UOM options");
    }
  };

  const generateItemCode = async () => {
    if (!parentCategory?.catCode) return;
    try {
      const res = await axios.get(
        `https://nissi-india.com/api/itemCode_generate/${parentCategory.catCode}`,
        { headers: commonHeaders }
      );
      const nextCode = res.data?.itemCode || res.data?.data?.itemCode;
      if (nextCode) setItemCode(nextCode);
    } catch (error) {
      toast.error("Failed to generate item code");
    }
  };

  const handleEdit = async (itemId) => {
    try {
      const res = await axios.get(
        `https://nissi-india.com/api/itemMaster_editFetch/${itemId}/${effectiveBranchId}`,
        { headers: commonHeaders }
      );

      const item = res.data?.item || (Array.isArray(res.data) ? res.data[0] : res.data);

      if (!item || !item.fld_itemcode) {
        toast.error("Item data not found or incomplete.");
        return;
      }

      const matchedUOM = uomOptions.find((uom) => uom.fld_uomid === item.fld_uomid);

      setEditingItem(item);
      setItemCode(item.fld_itemcode || "");
      setItemName(item.fld_itemname || "");
      setBaseUOM(matchedUOM?.fld_uomid || "");
      setPartNumber(item.fld_itemPartNo || "");
      setSerialNumber(item.fld_IsSerialNo ? "Yes" : "No");
      setUnderMaintenance(item.fld_IsUnderMaintenanceItem === true || item.fld_IsUnderMaintenanceItem === 1);
      setTallySeparateHeader(item.fld_IsTallySeperateItem === true || item.fld_IsTallySeperateItem === "True");
      setTallyHeaderName(item.fld_TallyHeaderName || "");
      setRemarks(item.fld_remarks || "");

setFormError("");
      setShowForm(true); // Auto expand form when editing
      toast.info("Form loaded in edit mode.");
    } catch (err) {
      console.error("Failed to fetch item details:", err);
      toast.error("Failed to load item for editing.");
    }
  };

const handleAddOrEditItem = async () => {
    setFormError("");

    if (!itemCode || !itemName || !baseUOM || !partNumber) {
      setFormError("Please fill all required fields.");
      return;
    }

    const raw_itemcode = itemCode.slice(-3);
    const commonPayload = {
      itemname: itemName,
      itemcode: itemCode,
      uomid: baseUOM,
      remarks: remarks || "",
      itemPartNo: partNumber,
      IsSerialNo: serialNumber === "Yes" ? 1 : 0,
      deepinnersubCategoryid: parentCategory.fld_deepinnersubCategoryid,
      Isundermaintenance: underMaintenance ? 1 : 0,
      Istally: tallySeparateHeader ? 1 : 0,
      Tallyheadername: tallyHeaderName || "",
    };

    try {
      if (editingItem) {
        const editPayload = {
          ...commonPayload,
          modifieduserid: Number(userId || 7),
        };

        await axios.put(
          `https://nissi-india.com/api/itemMaster_edit/${editingItem.itemid}`,
          editPayload,
          {
            headers: {
              ...commonHeaders,
              "Content-Type": "application/json",
            },
          }
        );
        toast.success("Item updated successfully.");
      } else {
        const insertPayload = {
          ...commonPayload,
          itemcategoryid: parentCategory.fld_itemcategoryid,
          raw_itemcode,
          userid: Number(userId || 7),
        };

        await axios.post("https://nissi-india.com/api/itemMaster_insert", insertPayload, {
          headers: {
            ...commonHeaders,
            "Content-Type": "application/json",
          },
        });
toast.success("Item added successfully.");
      }

      setFormError("");
      resetForm();
      fetchItemList();
    } catch (err) {
      console.error("Error submitting form:", err);
      const serverMsg = err.response?.data?.message || err.response?.data?.error;

      if (
        err.response?.status === 400 &&
        serverMsg?.toLowerCase().includes("already exists")
      ) {
        setFormError(serverMsg);
      } else {
        setFormError(serverMsg || "Error saving item.");
      }
    }
  };

  const resetForm = () => {
    setItemCode("");
    setItemName("");
    setBaseUOM("");
    setPartNumber("");
    setSerialNumber("No");
    setUnderMaintenance(false);
    setTallySeparateHeader(false);
    setTallyHeaderName("");
    setRemarks("");
    setEditingItem(null);
    if (!editingItem) generateItemCode();
  };

  const handleSelectCheckboxChange = (item) => {
    setSelectCheckboxItems((prev) =>
      prev.some((i) => i.itemid === item.itemid)
        ? prev.filter((i) => i.itemid !== item.itemid)
        : [...prev, item]
    );
  };

  const handleUpdateCheckboxChange = (item) => {
    const updatedList = updateCheckboxItems.some((i) => i.itemid === item.itemid)
      ? updateCheckboxItems.filter((i) => i.itemid !== item.itemid)
      : [...updateCheckboxItems, item];

    setUpdateCheckboxItems(updatedList);
    setIsTallyButtonEnabled(updatedList.length > 0);
  };

const handleTallyUpdate = () => {
    if (updateCheckboxItems.length === 0) {
      toast.warn("Please select items to update tally header.");
      return;
    }
    setShowTallyPrompt(true);
  };

  const confirmTallyUpdate = async (tallyName) => {
    setShowTallyPrompt(false);

    const payload = {
      itemIds: updateCheckboxItems.map((item) => item.itemid),
      branchId: 8,
      tallyHeaderName: tallyName,
      isTallyEnabled: 1,
    };

    try {
      await axios.post("https://nissi-india.com/api/tallyHeaderUpdate", payload, {
        headers: {
          ...commonHeaders,
          "Content-Type": "application/json",
        },
      });
      toast.success("Tally Header updated successfully.");
      setUpdateCheckboxItems([]);
      setIsTallyButtonEnabled(false);
      fetchItemList();
    } catch (error) {
      toast.error("Failed to update tally header.");
    }
  };

const handleDeleteSelected = () => {
    if (selectCheckboxItems.length === 0) {
      toast.warn("Please select items to delete");
      return;
    }
    setShowDeleteConfirm(true);
  };

  const confirmDeleteSelected = async () => {
    setShowDeleteConfirm(false);
    const ids = selectCheckboxItems.map((item) => item.itemid).join(",");
    try {
      await axios.delete(`https://nissi-india.com/api/itemMaster_delete/${ids}`, {
        headers: commonHeaders,
      });
      toast.success("Items deleted successfully");
      setSelectCheckboxItems([]);
      fetchItemList();
    } catch (error) {
      toast.error("Failed to delete items");
    }
  };

  useEffect(() => {
    if (!parentCategory) {
      navigate("/", { replace: true });
    } else {
      fetchItemList();
      fetchUOMOptions();
      if (!editingItem) {
        generateItemCode();
      }
    }
  }, [parentCategory, page]);

  if (!parentCategory) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-500">Redirecting...</p>
        </div>
      </div>
    );
  }

  return (
    <LayoutWrapper>
      <HeaderBar
        title={<span className="font-dmserif text-3xl">Item Master</span>}
        setSkin={setSkin}
        currentSkin={skin}
      />

      <div className="space-y-6 mt-6">
        {/* Parent Category Info */}
        <div
          className={`p-6 rounded-2xl shadow-xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : `bg-white ${currentSkin.glass} text-black border-gray-200`
          }`}
        >
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
            <div>
              <h1 className="text-2xl font-bold mb-1">Item Master</h1>
              <p className={`text-sm ${isDark ? "text-gray-300" : "text-gray-600"}`}>
                Managing items under Deep Inner:{" "}
                <span className="font-semibold text-blue-600">
                  {parentCategory?.fld_deepinnersubCategoryCode}
                </span>
              </p>
            </div>

            <div className="relative">
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                placeholder="Search items..."
                className={`w-64 pl-4 pr-4 py-2.5 rounded-xl text-sm border-2 transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                  isDark
                    ? "bg-gray-800/50 text-gray-200 border-gray-600"
                    : "bg-white text-black border-gray-300"
                }`}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { label: "Category Code", value: parentCategory?.fld_itemcategoryCode },
              { label: "Sub Category Code", value: parentCategory?.fld_itemsubCategoryCode },
              { label: "Inner Sub Category Code", value: parentCategory?.fld_innersubCategoryCode },
              { label: "Deep Inner Sub Category Code", value: parentCategory?.fld_deepinnersubCategoryCode },
            ].map((item, idx) => (
              <div
                key={idx}
                className={`p-4 rounded-xl border-2 ${
                  isDark
                    ? "bg-gray-800/30 border-gray-600"
                    : "bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200"
                }`}
              >
                <div className={`text-xs font-medium mb-1 ${isDark ? "text-gray-400" : "text-gray-600"}`}>
                  {item.label}
                </div>
                <div className={`font-bold text-lg ${isDark ? "text-white" : "text-gray-900"}`}>
                  {item.value || "-"}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ==================== POLISHED FORM SECTION ==================== */}
        <div
          className={`relative overflow-hidden rounded-2xl shadow-xl border transition-all duration-300 ${
            isDark
              ? `${currentSkin.dark} border-slate-700/50`
              : `bg-gray-300 border-slate-200/60`
          }`}
        >
          {/* Form Header with Collapse Button */}
          <div
            className={`relative px-6 py-4 border-b flex items-center justify-between ${
              isDark
                ? "border-slate-700/50 bg-slate-900/60"
                : "border-slate-200/50 bg-white/60"
            } backdrop-blur-md`}
          >
            <div className="flex items-center gap-3">
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-${baseColor}-500 to-${baseColor}-600 shadow-md shadow-${baseColor}-500/25`}
              >
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.99 1.99 0 013 12V7a4 4 0 014-4z"
                  />
                </svg>
              </div>

              <div>
                <h3 className={`text-lg font-bold tracking-tight ${isDark ? "text-white" : "text-slate-900"}`}>
                  {editingItem ? "Edit Item" : "Add New Item"}
                </h3>
                <p className={`text-xs font-medium ${isDark ? "text-slate-400" : "text-slate-600"}`}>
                  {editingItem ? "Update the item details below" : "Fill in the details to create a new item"}
                </p>
              </div>
            </div>

            {/* Collapse / Expand Button */}
            <button
              onClick={() => setShowForm(!showForm)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border transition-all ${
                isDark
                  ? "border-slate-600 text-slate-300 hover:bg-slate-800"
                  : "border-slate-300 text-slate-700 hover:bg-slate-100"
              }`}
            >
              {showForm ? (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                  </svg>
                  Hide Form
                </>
              ) : (
                <>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                  Show Form
                </>
              )}
            </button>
          </div>

{/* Collapsible Form Body */}
          {showForm && (
            <div className="relative p-6">
              {formError && (
                <div
                  className={`flex items-center justify-between gap-3 mb-4 px-4 py-2.5 rounded-lg border text-sm font-medium ${
                    isDark
                      ? "bg-red-900/30 border-red-500/40 text-red-300"
                      : "bg-red-50 border-red-200 text-red-700"
                  }`}
                >
                  <span>{formError}</span>
                  <button
                    type="button"
                    onClick={() => setFormError("")}
                    className="shrink-0 opacity-70 hover:opacity-100"
                    aria-label="Dismiss error"
                  >
                    ✕
                  </button>
                </div>
              )}

              <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                {/* Item Code */}
                <div className="space-y-1.5">
                  <label className={`flex items-center gap-1.5 text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Item Code <span className="text-red-500 font-bold">*</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded-full font-semibold uppercase border ${isDark ? "bg-emerald-900/30 text-emerald-400 border-emerald-500/30" : "bg-emerald-100 text-emerald-700 border-emerald-200"}`}>
                      Auto
                    </span>
                  </label>
                  <input
                    type="text"
                    value={itemCode}
                    onClick={() => {
                      if (!editingItem) generateItemCode();
                    }}
                    readOnly={!!editingItem}
                    className={`w-full px-3 py-2 rounded-lg border text-sm font-semibold tracking-wide ${
                      isDark
                        ? "bg-slate-800/60 border-slate-600/50 text-white"
                        : "bg-white border-slate-300 text-slate-900"
                    } ${editingItem ? "cursor-not-allowed opacity-80" : "cursor-pointer"}`}
                    placeholder="Click to generate code"
                  />
                </div>

                {/* Item Name */}
                <div className="space-y-1.5">
                  <label className={`flex items-center gap-1.5 text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Item Name <span className="text-red-500 font-bold">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      value={itemName}
                      onChange={(e) => setItemName(e.target.value)}
                      maxLength={100}
                      className={`w-full px-3 py-2 rounded-lg border text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-${baseColor}-500/30 focus:border-${baseColor}-500 ${
                        isDark
                          ? "bg-slate-800/60 border-slate-600/50 text-white placeholder-slate-400"
                          : "bg-white border-slate-300 text-slate-900 placeholder-slate-400"
                      }`}
                      placeholder="Enter item name"
                    />
                    <div className={`absolute -bottom-4 right-0 text-[10px] font-medium ${isDark ? "text-slate-500" : "text-slate-400"}`}>
                      {itemName.length}/100
                    </div>
                  </div>
                </div>

                {/* Base UOM */}
                <div className="space-y-1.5">
                  <label className={`flex items-center gap-1.5 text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Base UOM <span className="text-red-500 font-bold">*</span>
                  </label>
                  <select
                    value={baseUOM}
                    onChange={(e) => setBaseUOM(e.target.value)}
                    className={`w-full px-3 py-2 rounded-lg border text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-${baseColor}-500/30 focus:border-${baseColor}-500 ${
                      isDark
                        ? "bg-slate-800/60 border-slate-600/50 text-white"
                        : "bg-white border-slate-300 text-slate-900"
                    }`}
                  >
                    <option value="">Select UOM</option>
                    {uomOptions.map((uom) => (
                      <option key={uom.fld_uomid} value={uom.fld_uomid}>
                        {uom.fld_uomname}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Part Number */}
                <div className="space-y-1.5">
                  <label className={`flex items-center gap-1.5 text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Part Number <span className="text-red-500 font-bold">*</span>
                  </label>
                 <input
  type="text"
  value={partNumber}
  onChange={(e) => setPartNumber(e.target.value)}
  maxLength={200}
  className={`w-full px-3 py-2 rounded-lg border text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-${baseColor}-500/30 focus:border-${baseColor}-500 ${
    isDark
      ? "bg-slate-800/60 border-slate-600/50 text-white placeholder-slate-400"
      : "bg-white border-slate-300 text-slate-900 placeholder-slate-400"
  }`}
  placeholder="Enter part number"
/>
                </div>

                {/* Serial Number */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Serial Number <span className="text-red-500 font-bold">*</span>
                  </label>
                  <div className="flex items-center gap-6 mt-2">
                    {["Yes", "No"].map((option) => (
                      <label key={option} className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="serialNumber"
                          value={option}
                          checked={serialNumber === option}
                          onChange={() => setSerialNumber(option)}
                          className={`w-4 h-4 accent-${baseColor}-500`}
                        />
                        <span className={`text-sm font-medium ${isDark ? "text-slate-200" : "text-slate-700"}`}>
                          {option}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Checkboxes */}
                <div className="space-y-3">
                  <label
                    className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                      isDark
                        ? "border-slate-600/50 bg-slate-800/30 hover:bg-slate-800/50"
                        : "border-slate-300/60 bg-slate-50/50 hover:bg-slate-100/50"
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={underMaintenance}
                      onChange={(e) => setUnderMaintenance(e.target.checked)}
                      className={`w-4 h-4 rounded accent-${baseColor}-500`}
                    />
                    <span className={`text-sm font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>
                      Under Maintenance Item
                    </span>
                  </label>

                  <label
                    className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                      isDark
                        ? "border-slate-600/50 bg-slate-800/30 hover:bg-slate-800/50"
                        : "border-slate-300/60 bg-slate-50/50 hover:bg-slate-100/50"
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={tallySeparateHeader}
                      onChange={(e) => setTallySeparateHeader(e.target.checked)}
                      className={`w-4 h-4 rounded accent-${baseColor}-500`}
                    />
                    <span className={`text-sm font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>
                      Tally Separate Header
                    </span>
                  </label>

                  {tallySeparateHeader && (
                    <input
                      type="text"
                      placeholder="Enter Tally Header Name"
                      value={tallyHeaderName}
                      onChange={(e) => setTallyHeaderName(e.target.value)}
                      className={`w-full px-3 py-2 rounded-lg border text-sm mt-2 ${
                        isDark
                          ? "bg-slate-800/60 border-slate-600/50 text-white"
                          : "bg-white border-slate-300 text-slate-900"
                      }`}
                    />
                  )}
                </div>

                {/* Remarks */}
                <div className="xl:col-span-2 space-y-1.5">
                  <label className={`text-xs font-semibold tracking-wide ${isDark ? "text-slate-300" : "text-slate-700"}`}>
                    Remarks
                  </label>
                  <div className="relative">
                    <textarea
  value={remarks}
  onChange={(e) => setRemarks(e.target.value)}
  rows={3}
  maxLength={250}
  className={`w-full px-3 py-2 rounded-lg border text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-violet-500/30 focus:border-violet-500 resize-none ${
    isDark
      ? "bg-slate-800/60 border-slate-600/50 text-white placeholder-slate-400"
      : "bg-white border-slate-300 text-slate-900 placeholder-slate-400"
  }`}
  placeholder="Optional notes about this item..."
/>
<div className={`absolute -bottom-4 right-0 text-[10px] font-medium ${isDark ? "text-slate-500" : "text-slate-400"}`}>
  {remarks.length}/250
</div>
                  </div>
                </div>
              </div>

              {/* Form Buttons */}
              <div className="flex flex-wrap justify-end gap-3 mt-8 pt-4 border-t border-slate-200/60 dark:border-slate-700/60">
                {editingItem && (
                  <button
                    onClick={resetForm}
                    type="button"
                    className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
                      isDark
                        ? "border-slate-600 text-slate-300 hover:bg-slate-800"
                        : "border-slate-300 text-slate-700 hover:bg-slate-100"
                    }`}
                  >
                    Cancel Edit
                  </button>
                )}

                <button
                  onClick={handleAddOrEditItem}
                  className={`px-5 py-2 text-sm font-semibold text-white rounded-lg shadow transition-colors bg-${baseColor}-600 hover:bg-${baseColor}-700`}
                >
                  {editingItem ? "Update Item" : "Save Item"}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ==================== TABLE SECTION ==================== */}
        <div
          className={`rounded-2xl shadow-xl border overflow-hidden ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10"
              : `bg-white ${currentSkin.glass} border-gray-200`
          }`}
        >
          <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className={`w-3 h-8 rounded-full bg-${baseColor}-${baseShade}`}></div>
                <h3 className="text-xl font-bold">Items List</h3>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={handleTallyUpdate}
                  disabled={!isTallyButtonEnabled}
                  className={`px-4 py-2 text-white text-sm font-semibold rounded-lg shadow transition ${
                    isTallyButtonEnabled
                      ? "bg-green-600 hover:bg-green-700"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                >
                  📜 Tally Header Update
                </button>

                <button
                  onClick={handleDeleteSelected}
                  disabled={selectCheckboxItems.length === 0}
                  className={`px-4 py-2 text-white text-sm font-semibold rounded-lg shadow transition ${
                    selectCheckboxItems.length > 0
                      ? "bg-red-600 hover:bg-red-700"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                >
                  🗑 Delete ({selectCheckboxItems.length})
                </button>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className={`bg-gradient-to-r from-${baseColor}-600 to-${baseColor}-700 text-white`}>
                <tr>
                  {[
                    "S.No",
                    "Item Category",
                    "Item Code",
                    "Item Name",
                    "Part No",
                    "Base UOM",
                    "Serial No",
                    "Update",
                    "Edit",
                    "Select",
                    "Send SMS",
                  ].map((header, idx) => (
                    <th key={idx} className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className={`divide-y ${isDark ? "divide-gray-600" : "divide-gray-200"}`}>
                {loading ? (
                  [...Array(limit)].map((_, idx) => (
                    <tr key={idx}>
                      {[...Array(11)].map((_, cell) => (
                        <td key={cell} className="px-4 py-3">
                          <Skeleton height={20} baseColor={isDark ? "#374151" : "#f3f4f6"} />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : itemList.length === 0 ? (
                  <tr>
                    <td colSpan={11} className="text-center py-12 text-gray-500">
                      No items found
                    </td>
                  </tr>
                ) : (
                  itemList.map((item, idx) => (
                    <tr
                      key={item.itemid}
                      className={`${isDark ? "bg-gray-800/20 hover:bg-gray-700/30" : "bg-white hover:bg-gray-50"} transition`}
                    >
                      <td className="px-4 py-3">{(page - 1) * limit + idx + 1}</td>
                      <td className="px-4 py-3">{item.fld_itemcategory_name}</td>
                      <td className="px-4 py-3">
                        <span className={`inline-block px-2 py-1 rounded text-xs font-semibold bg-${baseColor}-100 text-${baseColor}-800`}>
                          {item.fld_itemcode}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <a
                          href={`/inventory/ItemDetails?itemid=${item.itemid}&itemCode=${encodeURIComponent(item.fld_itemcode)}&itemName=${encodeURIComponent(item.fld_itemname)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline font-medium"
                        >
                          {item.fld_itemname}
                        </a>
                      </td>
                      <td className="px-4 py-3">{item.fld_itemPartNo || "-"}</td>
                      <td className="px-4 py-3">{item.fld_uomname}</td>
                      <td className="px-4 py-3">
                        <span
                          className={`inline-block px-2 py-1 rounded-full text-xs font-semibold ${
                            item.fld_IsSerialNo ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
                          }`}
                        >
                          {item.fld_IsSerialNo ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <input
                          type="checkbox"
                          checked={updateCheckboxItems.some((cat) => cat.itemid === item.itemid)}
                          onChange={() => handleUpdateCheckboxChange(item)}
                          className="w-4 h-4"
                        />
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() => handleEdit(item.itemid)}
                          className="text-yellow-500 hover:text-yellow-600 text-lg"
                          title="Edit"
                        >
                          ✏️
                        </button>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <input
                          type="checkbox"
                          checked={selectCheckboxItems.some((cat) => cat.itemid === item.itemid)}
                          onChange={() => handleSelectCheckboxChange(item)}
                          className="w-4 h-4"
                        />
                      </td>
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() =>
                            window.open(
                              `/inventory/SendSMS?itemCode=${encodeURIComponent(item.fld_itemcode)}&itemName=${encodeURIComponent(item.fld_itemname)}`,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                          className="text-blue-500 hover:text-blue-700 text-lg"
                          title="Send SMS"
                        >
                          📩
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div
          className={`p-6 rounded-2xl shadow-xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : `bg-white ${currentSkin.glass} text-black border-gray-200`
          }`}
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>
              Showing page <span className="font-bold">{page}</span> of{" "}
              <span className="font-bold">{totalPages}</span>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className={`px-4 py-2 text-sm font-medium rounded-lg ${
                  page === 1 ? "text-gray-400 cursor-not-allowed" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                }`}
              >
                Prev
              </button>

              {[...Array(Math.min(totalPages, 5))].map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setPage(idx + 1)}
                  className={`w-10 h-10 text-sm font-medium rounded-lg ${
                    page === idx + 1
                      ? `bg-${baseColor}-${baseShade} text-white`
                      : "hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                >
                  {idx + 1}
                </button>
              ))}

              <button
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                className={`px-4 py-2 text-sm font-medium rounded-lg ${
                  page === totalPages ? "text-gray-400 cursor-not-allowed" : "hover:bg-gray-100 dark:hover:bg-gray-800"
                }`}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

<ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme={isDark ? "dark" : "light"}
        style={{ top: "90px", zIndex: 99999 }}
      />

      <ConfirmModal
        open={showDeleteConfirm}
        title="Delete Items"
        message={`Are you sure you want to delete ${selectCheckboxItems.length} selected item(s)? This action cannot be undone.`}
        confirmLabel="Delete"
        onConfirm={confirmDeleteSelected}
        onCancel={() => setShowDeleteConfirm(false)}
      />

      <PromptModal
        open={showTallyPrompt}
        title="Tally Header Update"
        message={`Enter the Tally Header Name for ${updateCheckboxItems.length} selected item(s).`}
        placeholder="Enter Tally Header Name"
        confirmLabel="Update"
        onConfirm={confirmTallyUpdate}
        onCancel={() => setShowTallyPrompt(false)}
      />
    </LayoutWrapper>
  );
};

export default ItemMaster;